const paperStyles = (theme) => ({
  width: {
    xs: "full", // 0
    sm: "full", // 600
    md: "full", // 900
    lg: "530", // 1200
    xl: "530px", // 1536
  },
  position: "absolute",
  padding: "30px",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  '@media screen and (max-width: 500px)': {
    width: '100%',
    overflow: 'auto',
    height: '400px',
    marginTop: '10%'
  },
});

const boxStyles = (theme) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignContent: "center",
});

const buttonStyles = (theme) => ({
  background: "#FFEEEE",
  padding: "0px",
  width: "36px",
  height: "36px",
  minWidth: 0,
  borderRadius:"4px"
});

const cardcheckboxStyles = (theme) => ({
  width: "100%",
  display: "flex",
  
  justifyContent: {
    lg: "space-between",
    xl: "space-between",
  },
  '@media screen and (max-width: 500px)': {
    display: 'flex',
    flexDirection: 'column',
    width: '60%',
    alignSelf: 'center'
  },
  '@media screen and (max-width: 400px)': {
    width: '100%',
  },
});

export { paperStyles, boxStyles, buttonStyles, cardcheckboxStyles };
